import React, { useEffect, useState } from "react";
import PageHeader from "components/PageHeader";
import ApartmentSingle from "components/Apartment/ApartmentSingle";
import clg from "functions/log";
import routes from "configs/routes";
import {
  formatFloor,
  formatMoney,
  formatRoomType,
} from "functions/formatDynamicData";
import { Helmet } from "react-helmet";
import settings from "configs/settings";

import static_background_image from "assets/images/csango10-elado-lakasok.webp";

const Apartment = ({ match }) => {
  const apartmentId = match.params.id;

  const [pageHeaderData, setPageHeaderData] = useState({
    backgroundImage: null,
    features: [],
  });

  const _setPageHeaderData = (data) => {
    setPageHeaderData({
      backgroundImage: static_background_image /* data.images[0] */,
      title: `Lakás ${data.code && data.code}`,
      subtitle: formatRoomType(data.rooms, "title"),
      features: [
        {
          title: "Emelet",
          data: { value: formatFloor(data.floor) },
          iconClass: "large c-icon-floor",
          hasRealDataWithIcon: true,
        },
        //{ title : "Nettó alapterület", data : { value : data.floor_area, postfix: "m2", }, iconClass : "large c-icon-floor-area", hasRealDataWithIcon : true },
        {
          title: "Szobák",
          data: { value: data.rooms },
          iconClass: "large c-icon-room",
          hasRealDataWithIcon: true,
        },
        {
          title: "Ár *",
          data: {
            value:
              data.gross_price !== "0"
                ? formatMoney(data.gross_price, "M Ft")
                : "Érdeklődjön",
          },
          iconClass: "large c-icon-house-for-sale ",
          hasRealDataWithIcon: true,
        },
      ],
      exactRoutes: [{ to: routes.apartments }],
    });
  };


  return (
    <div>
      {pageHeaderData.title && (
        <Helmet>
          <title>
            {
              pageHeaderData.title +
              settings.pageTitlePostfix}
          </title>
        </Helmet>
      )}

      <PageHeader
        backgroundImage={pageHeaderData.backgroundImage}
        featuresEnabled={true}
        featuresData={pageHeaderData.features}
        featureItemClass="col-12 col-sm-6 col-lg-3 room-data-feature-item"
        featuresRowClass="justify-content-center"
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />

      <ApartmentSingle id={apartmentId} callback={_setPageHeaderData} />
    </div>
  );
};

export default Apartment;
